module.exports = __webpack_public_path__ + "media/Images/LeafBig2-7d83b063.svg";